/**
 * When setting DOM attributes such as `data-active`
 * any value (except undefined) will set `data-active={value}`
 */
export function trueOrUndef(boolish?: boolean | null | 0 | "") {
  return boolish || undefined;
}
